import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";

export default function StoreBrandDeleteModal({
  open,
  onClose,
  onConfirm,
  brand,
  loading,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Eliminar marca</DialogTitle>

      <DialogContent>
        <Typography fontWeight={600}>
          {brand?.name}
        </Typography>

        <Typography fontSize={13} color="#64748b">
          Solo se eliminará si no tiene productos asociados.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancelar
        </Button>

        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            height: 36,
            px: 1.4,
            borderRadius: "9px",
            textTransform: "none",
            fontWeight: 600,
            fontSize: 12.8,
            bgcolor: "#0f172a",
            boxShadow: "none",
            "&:hover": {
              bgcolor: "#111827",
              boxShadow: "none",
            },
          }}
          disabled={loading}
        >
          Eliminar
        </Button>
      </DialogActions>
    </Dialog>
  );
}